import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ userRole = 'admin', recentActions = [] }) => {
  const navigate = useNavigate();

  const quickActionItems = [
    {
      id: 'new-project',
      title: 'Novo Projeto',
      description: 'Criar projeto de consultoria',
      icon: 'FolderPlus',
      color: 'primary',
      path: '/project-management',
      roles: ['admin']
    },
    {
      id: 'new-order',
      title: 'Nova OS',
      description: 'Criar ordem de serviço',
      icon: 'Plus',
      color: 'success',
      path: '/service-orders',
      roles: ['admin', 'technician']
    },
    {
      id: 'assign-technician',
      title: 'Atribuir Técnico',
      description: 'Designar técnico para OS',
      icon: 'UserPlus',
      color: 'warning',
      path: '/service-orders',
      roles: ['admin']
    },
    {
      id: 'client-portal',
      title: 'Portal Cliente',
      description: 'Acessar portal do cliente',
      icon: 'Users',
      color: 'secondary',
      path: '/client-portal',
      roles: ['admin', 'client']
    },
    {
      id: 'reports',
      title: 'Relatórios',
      description: 'Gerar relatórios',
      icon: 'BarChart3',
      color: 'accent',
      path: '/admin-dashboard',
      roles: ['admin']
    },
    {
      id: 'mobile-app',
      title: 'App Móvel',
      description: 'Acessar versão móvel',
      icon: 'Smartphone',
      color: 'primary',
      path: '/technician-mobile',
      roles: ['technician']
    }
  ];

  const availableActions = quickActionItems?.filter(action => 
    action?.roles?.includes(userRole)
  );

  const getColorClasses = (color) => {
    switch (color) {
      case 'success':
        return 'bg-success/10 text-success hover:bg-success/20 border-success/20';
      case 'warning':
        return 'bg-warning/10 text-warning hover:bg-warning/20 border-warning/20';
      case 'secondary':
        return 'bg-secondary/10 text-secondary hover:bg-secondary/20 border-secondary/20';
      case 'accent':
        return 'bg-accent/10 text-accent hover:bg-accent/20 border-accent/20';
      default:
        return 'bg-primary/10 text-primary hover:bg-primary/20 border-primary/20';
    }
  };

  const handleQuickAction = (action) => {
    navigate(action?.path);
  };

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="p-6 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Ações Rápidas</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Acesso rápido às funcionalidades principais
        </p>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
          {availableActions?.map((action) => (
            <button
              key={action?.id}
              onClick={() => handleQuickAction(action)}
              className={`p-4 rounded-lg border transition-all hover:scale-105 ${getColorClasses(action?.color)}`}
            >
              <div className="flex flex-col items-center text-center space-y-2">
                <div className="w-12 h-12 rounded-lg bg-current/10 flex items-center justify-center">
                  <Icon name={action?.icon} size={24} />
                </div>
                <div>
                  <p className="font-medium text-sm">{action?.title}</p>
                  <p className="text-xs opacity-75 mt-1">{action?.description}</p>
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Recent Actions */}
        {recentActions?.length > 0 && (
          <div>
            <h4 className="text-sm font-medium text-foreground mb-3">Ações Recentes</h4>
            <div className="space-y-2">
              {recentActions?.slice(0, 3)?.map((action, index) => (
                <div key={index} className="flex items-center space-x-3 p-2 rounded-lg hover:bg-muted/50 transition-colors">
                  <div className="w-8 h-8 bg-muted rounded-lg flex items-center justify-center">
                    <Icon name={action?.icon} size={16} className="text-muted-foreground" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground truncate">
                      {action?.title}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {action?.timestamp}
                    </p>
                  </div>
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="ArrowRight"
                    onClick={() => navigate(action?.path)}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuickActions;